import { authApi } from '@auto-cargo/protocol-sdk';

// Re-export shared types
export type { AuthEnvelope as ApiEnvelope, CaptchaResult as SchedulingCaptchaResult, LoginResult as SchedulingLoginResult } from '@auto-cargo/protocol-sdk';

// Re-export shared auth API with scheduling-compatible name
export const schedulingAuthApi = authApi;
export default schedulingAuthApi;
